/** SEO-подписи тем и компактные H1 каталога (без маркетингового intro). */

export const TOPIC_SEO_LABEL_RU: Record<string, string> = {
  SQL: 'SQL',
  Algorithms: 'алгоритмам',
  Math: 'математике',
  Physics: 'физике',
  Специальные: 'специальным задачам',
};

export function topicSeoLabelRu(topic: string): string {
  return TOPIC_SEO_LABEL_RU[topic] || topic;
}

/**
 * Короткий H1 под запрос («Задачи по SQL»), без абзаца на странице.
 * Meta description остаётся отдельно в ProblemsList.
 */
const LANDING_H1: Record<string, { ru: string; en: string }> = {
  All: {
    ru: 'Задачи по программированию',
    en: 'Programming problems',
  },
  SQL: {
    ru: 'Задачи по SQL',
    en: 'SQL problems',
  },
  Algorithms: {
    ru: 'Задачи по алгоритмам',
    en: 'Algorithm problems',
  },
  Math: {
    ru: 'Задачи по математике',
    en: 'Math problems',
  },
  Physics: {
    ru: 'Задачи по физике',
    en: 'Physics problems',
  },
  Специальные: {
    ru: 'Специальные задачи',
    en: 'Special problems',
  },
};

export function getTopicLandingH1(topic: string, lang: string): string {
  const key = !topic || topic === 'All' ? 'All' : topic;
  const pack = LANDING_H1[key] || {
    ru: `Задачи по ${topicSeoLabelRu(key)}`,
    en: `${key} problems`,
  };
  return lang === 'ru' ? pack.ru : pack.en;
}
